import React from 'react';
import { Link } from 'react-router-dom';

// Redes sociais do Fé Escrita — preencher as URLs quando existirem (null oculta o link)
const INSTAGRAM_URL = null;
const TIKTOK_URL = null;

function Footer() {
  return (
    <footer className="fe-footer">
      <div className="fe-footer-inner">
        <div>
          <div className="fe-footer-wordmark">Fé Escrita</div>
          <div className="fe-footer-copy">© 2026 Fé Escrita · Reflexões cristãs diárias</div>
        </div>
        <nav className="fe-footer-nav">
          <a href="https://www.youtube.com/@CoracaoCristao-go7ms" target="_blank" rel="noopener noreferrer">
            Coração Cristão
          </a>
          {INSTAGRAM_URL && (
            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer">
              Instagram
            </a>
          )}
          {TIKTOK_URL && (
            <a href={TIKTOK_URL} target="_blank" rel="noopener noreferrer">
              TikTok
            </a>
          )}
          <Link to="/about">Sobre</Link>
          <Link to="/privacy-policy">Política de Privacidade</Link>
        </nav>
      </div>
    </footer>
  );
}

export default Footer;
